const SELECTED_ITEMS_KEY = 'selected_items'

export function setSelectedItems(state) {
  const { selected_items: selectedItems } = state

  if (Array.isArray(selectedItems)) {
    localStorage.setItem(SELECTED_ITEMS_KEY, JSON.stringify(selectedItems))
  } else {
    localStorage.removeItem(SELECTED_ITEMS_KEY)
  }
}

export function getSelectedItems() {
  const stored = localStorage.getItem(SELECTED_ITEMS_KEY)

  if (!stored) return {}

  try {
    const parsed = JSON.parse(stored)
    return { selected_items: Array.isArray(parsed) ? parsed : [] }
  } catch {
    localStorage.removeItem(SELECTED_ITEMS_KEY)
    return {}
  }
}
